<template>
  <div v-if="params.value.id && params.value.label" class="flex items-center">
    <a @click="submitPackage" href="javascript:void(0)">{{ text }}</a>
  </div>
  <div v-else-if="params.value.label_error" style="margin-top: 23px;" @click="error">
    <vs-chip class="ag-grid-cell-chip cursor-pointer" color="danger">
      <span>Erro</span>
    </vs-chip>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  methods: {
    submitPackage() {
      this.$vs.loading();
      let package_id = this.params.data.id;
      this.$store.dispatch("packageManagement/registerLabels", package_id)
        .then(res => {
          console.log(res);
          this.$vs.loading.close();
          document.location.href = res.data.url;
        })
        .catch(err => {
          console.error({ err: err.response });
        });
    },
    error() {
      console.log('Método de erro chamado');
      console.log('Erro: ', this.params.value.label_error);
      this.$vs.notify({
        time: 20000,
        title: 'Atenção',
        text: `${this.params.value.label_error}`,
        color: 'danger',
        iconPack: 'feather',
        icon: 'icon-alert-circle'
      });
    }
  },
  computed: {
    url() {
      return "https://samurai-gadolapps-sedex-plp.s3.us-west-1.amazonaws.com/envios/sigep/" + this.params.value.id + "_merged.pdf";
            // Below line will be for actual product
            // Currently it's commented due to demo purpose - Above url is for demo purpose
            // return "/apps/user/user-view/" + this.params.data.id
    },
    text() {
      return this.params.value.label;
            // Below line will be for actual product
            // Currently it's commented due to demo purpose - Above url is for demo purpose
            // return "/apps/user/user-view/" + this.params.data.id
    }
  },
}
</script>
